<div class="flex-row padding-30">
  <div class="flex-1"></div>
  <div class="flex-3">
    <form [formGroup]="profileForm" (ngSubmit)="onSubmit()" class="form-content">
      <h1 class="margin-bottom-25 center-text">Update Profile</h1>

      @if (loading) {
        <mat-progress-bar style="height: 4px; width: 400px; margin: 0 auto;" mode="indeterminate"></mat-progress-bar>
      }

      <mat-form-field class="form-group flex-row">
        <mat-label>First Name</mat-label>
        <input matInput readonly type="text" formControlName="firstName" [ngClass]="{ 'is-invalid': submitted && formControls.firstName.errors }" />
        @if (submitted && formControls.firstName.errors) {
          <div class="invalid-feedback">
            @if (formControls.firstName.errors.required) {
              <div>First name is required</div>
            }
          </div>
        }
      </mat-form-field>

      <mat-form-field class="form-group flex-row">
        <mat-label>Last Name</mat-label>
        <input matInput readonly type="text" formControlName="lastName" [ngClass]="{ 'is-invalid': submitted && formControls.lastName.errors }" />
        @if (submitted && formControls.lastName.errors) {
          <div class="invalid-feedback">
            @if (formControls.lastName.errors.required) {
              <div>Last name is required</div>
            }
          </div>
        }
      </mat-form-field>

      <mat-form-field class="form-group flex-row">
        <mat-label>Date of Birth</mat-label>
        <input matInput [matDatepicker]="dp" formControlName="dateOfBirth" [ngClass]="{ 'is-invalid': submitted && formControls.lastName.errors }" />
        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
        <mat-datepicker #dp></mat-datepicker>

        @if (submitted && formControls.lastName.errors) {
          <div class="invalid-feedback">
            @if (formControls.lastName.errors.required) {
              <div>Date of Birth is required</div>
            }
          </div>
        }
      </mat-form-field>

      <mat-form-field class="form-group flex-row">
        <mat-label>Email Address</mat-label>
        <input matInput readonly type="text" formControlName="emailAddress" [ngClass]="{ 'is-invalid': submitted && formControls.emailAddress.errors }" />
        @if (submitted && formControls.emailAddress.errors) {
          <div class="invalid-feedback">
            @if (formControls.emailAddress.errors.required) {
              <div>Email adress is required</div>
            }
          </div>
        }
      </mat-form-field>

      <mat-form-field class="form-group flex-row">
        <mat-label>Address *</mat-label>
        <input matInput type="text" formControlName="address" [ngClass]="{ 'is-invalid': submitted && formControls.address.errors }" />
        @if (submitted && formControls.address.errors) {
          <div class="invalid-feedback">
            @if (formControls.address.errors.required) {
              <div>Address is required</div>
            }
          </div>
        }
      </mat-form-field>

      <mat-form-field class="form-group flex-row">
        <mat-label>City *</mat-label>
        <input matInput type="text" formControlName="city" [ngClass]="{ 'is-invalid': submitted && formControls.city.errors }" />
        @if (submitted && formControls.city.errors) {
          <div class="invalid-feedback">
            @if (formControls.city.errors.required) {
              <div>City is required</div>
            }
          </div>
        }
      </mat-form-field>

      <mat-form-field class="form-group flex-row">
        <mat-label>State *</mat-label>
        <input matInput type="text" formControlName="state" [ngClass]="{ 'is-invalid': submitted && formControls.state.errors }" />
        @if (submitted && formControls.state.errors) {
          <div class="invalid-feedback">
            @if (formControls.state.errors.required) {
              <div>State is required</div>
            }
          </div>
        }
      </mat-form-field>

      <mat-form-field class="form-group flex-row">
        <mat-label>ZipCode *</mat-label>
        <input matInput type="number" formControlName="zipCode" [ngClass]="{ 'is-invalid': submitted && formControls.zipCode.errors }" />
        @if (submitted && formControls.zipCode.errors) {
          <div class="invalid-feedback">
            @if (formControls.zipCode.errors.required) {
              <div>Zip Code is required</div>
            }
          </div>
        }
      </mat-form-field>

      <mat-form-field class="form-group flex-row">
        <mat-label>Primary Phone Number *</mat-label>
        <input  matInput
          type="tel"
          formControlName="primaryPhoneNumber"
          [ngClass]="{ 'is-invalid': submitted && formControls.primaryPhoneNumber.errors }" />
          @if (submitted && formControls.primaryPhoneNumber.errors) {
            <div class="invalid-feedback">
              @if (formControls.primaryPhoneNumber.errors.required) {
                <div>Primary phone number is required</div>
              }
            </div>
          }
        </mat-form-field>

        <mat-form-field class="form-group flex-row">
          <mat-label>Secondary Phone Number *</mat-label>
          <input  matInput
            type="tel"
            formControlName="secondaryPhoneNumber"
            [ngClass]="{ 'is-invalid': submitted && formControls.secondaryPhoneNumber.errors }"/>
          </mat-form-field>

          <div class="flex-row">
            <div class="flex-2"></div>
            @if (!saving) {
              <button [disabled]="loading" class="btn btn-primary btn-size flex-3">
                @if (loading) {
                  <span class="spinner-border spinner-border-sm mr-1"></span>
                }
                Save
              </button>
            }

            @if (saving) {
              <mat-progress-bar style="height: 4px;" class="flex-3" mode="indeterminate"></mat-progress-bar>
            }

            <div class="flex-2"></div>
          </div>
        </form>
      </div>
      <div class="flex-1"></div>
    </div>